<template lang="pug">
  div
    v-row(no-gutters :align="align")
      // Merge text
      v-col.pa-2(cols="2")
        slot(name="firstColumn")
      // Merge from
      v-col.pa-2
        slot(name="secondColumn")
      v-divider.border-color(vertical)
      // Merge into
      v-col.pa-2
        slot(name="thirdColumn")
    v-divider.border-color(v-if="showDivider")
</template>

<script>
export default {
  props: {
    showDivider: {
      type: Boolean,
    },
    align: {
      type: String,
      default: 'center',
    },
  },
}
</script>

<style scoped>
.border-color {
  border: 1px solid #EEEEEE;
}
</style>